module.exports = __webpack_public_path__ + "img/shopping.5573d0de.png";